import { Component, useState } from "react";
import Image from "react-bootstrap/Image";
import MagicDropzone from "react-magic-dropzone";
import rightImage from "./imageright.png";
import frontProfile from "./imagefrontprofil.png";
import frontProfileSmile from "./imageprofilsmile.png";
import leftintra from "./left_intra.png";
import logo from "./logo.png";
import rightintra from "./right_intra.png";
import frontintra from "./front_intra.png";
import maxokluzal from "./max_okluzal.png";
import manokluzal from "./man_okluzal.png";
import panoramic from "./pano.jpg";
import sefalometric from "./sefo.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import ImageEdit from "./ImageEdit";

const ImagesAndFilesComp = (mainprops) => {
  const [value, setValue] = useState(
    "image/jpeg, image/png, .jpg, .jpeg, .png"
  );
  const [imageEditUrl, setImageEditUrl] = useState("test");
  const [imageId, setImageId] = useState("test");
  const [valueStl, setValueStl] = useState(".stl");
  const [modalShow, setModalShow] = useState(false);

  const onDrop = (id, accepted, rejected, links) => {
    let newPreviews = { ...mainprops.previews };
    newPreviews[id] = accepted[0];
    mainprops.onSetPreviews(newPreviews);
  };

  const setEditedImage = (id, file) => {
    let newPreviews = { ...mainprops.previews };
    newPreviews[id] = file;
    mainprops.onSetPreviews(newPreviews);
  };

  const ImageUploader = (props) => {
    const showImageEditor = (e) => {
      setImageEditUrl(mainprops.previews[props.Id].preview);
      setImageId(props.Id);
      setModalShow(true);
    };
    return (
      <div>
        <div className="Dropzone-page">
          {mainprops.previews[props.Id] !== undefined && (
            <Button
              variant="primary"
              className="edit-image-button"
              onClick={showImageEditor}
            >
              <i className="fa fa-pencil-square-o"></i>
            </Button>
          )}
          <MagicDropzone
            className="Dropzone"
            accept={value}
            onDrop={props.onDrop}
          >
            <div
              className="Dropzone-content"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {mainprops.previews[props.Id] != undefined ? (
                <Image
                  alt=""
                  className="Dropzone-img"
                  src={mainprops.previews[props.Id].preview}
                  fluid
                />
              ) : (
                <Image
                  alt=""
                  className="Dropzone-img"
                  src={props.bgimage}
                  style={{ alignSelf: "center" }}
                  fluid
                />
              )}
            </div>
          </MagicDropzone>
        </div>
      </div>
    );
  };

  const ImageUploaderStl = (props) => {
    return (
      <div className="Dropzone-page">
        <MagicDropzone
          className="Dropzone"
          accept={valueStl}
          onDrop={props.onDrop}
        >
          <div
            className="Dropzone-content"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {mainprops.previews[props.Id] != undefined ? (
              <>
                <Image
                  alt=""
                  className="Dropzone-img"
                  src={props.bgimage}
                  style={{ alignSelf: "center" }}
                  fluid
                />
                <span>{mainprops.previews[props.Id].name}</span>
              </>
            ) : (
              <>
                <Image
                  alt=""
                  className="Dropzone-img"
                  src={props.bgimage}
                  style={{ alignSelf: "center" }}
                  fluid
                />
              </>
            )}
          </div>
        </MagicDropzone>
      </div>
    );
  };

  return (
    <div>
      {modalShow && (
        <ImageEdit
          imagePath={imageEditUrl}
          imageId={imageId}
          show={modalShow}
          onHide={() => setModalShow(false)}
          onSetEditedImage={setEditedImage}
        />
      )}
      <Container>
        <Row>
          {" "}
          <Form.Group className="mb-3">
            <Form.Label>CONTENT TYPE:</Form.Label>
            <Form.Select
              value={mainprops.contentType}
              onChange={(e) => mainprops.onContentType(e.target.value)}
            >
              <option value="">Select Content Type</option>
              <option value="Alçı model">ALÇI MODEL</option>
              <option value="Kaşık">ÖLÇÜ KAŞIĞI</option>
              <option value="STL">DİJİTAL TARAMA</option>
            </Form.Select>
          </Form.Group>
        </Row>
        {mainprops.contentType == "STL" && (
          <div>
            <Row>
              <h3>Stl File Upper Arch:</h3>
              <Col className="col-12">
                {" "}
                <ImageUploaderStl
                  Id="Img11"
                  key="11"
                  onDrop={(...params) => {
                    onDrop("Img11", ...params);
                  }}
                  bgimage={maxokluzal}
                />{" "}
              </Col>
            </Row>
            <Row>
              <h3>Stl File Lower Arch:</h3>
              <Col className="col-12">
                {" "}
                <ImageUploaderStl
                  Id="Img12"
                  key="12"
                  onDrop={(...params) => {
                    onDrop("Img12", ...params);
                  }}
                  bgimage={manokluzal}
                />{" "}
              </Col>
            </Row>
          </div>
        )}

        <Row>
          <h3>Intraoral Images:</h3>
        </Row>
        <Row>
          <Col>
            {" "}
            <ImageUploader
              Id="Img1"
              key="1"
              onDrop={(...params) => {
                onDrop("Img1", ...params);
              }}
              bgimage={rightImage}
            />{" "}
          </Col>
          <Col>
            {" "}
            <ImageUploader
              Id="Img2"
              key="2"
              onDrop={(...params) => {
                onDrop("Img2", ...params);
              }}
              bgimage={frontProfile}
            />{" "}
          </Col>
          <Col>
            {" "}
            <ImageUploader
              Id="Img3"
              key="3"
              onDrop={(...params) => {
                onDrop("Img3", ...params);
              }}
              bgimage={frontProfileSmile}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col>
            {" "}
            <ImageUploader
              Id="Img4"
              key="4"
              onDrop={(...params) => {
                onDrop("Img4", ...params);
              }}
              bgimage={maxokluzal}
            />{" "}
          </Col>
          <Col>
            {" "}
            <Image alt="" className="Dropzone-img" src={logo} fluid />
          </Col>
          <Col>
            {" "}
            <ImageUploader
              Id="Img5"
              key="5"
              onDrop={(...params) => {
                onDrop("Img5", ...params);
              }}
              bgimage={manokluzal}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col>
            {" "}
            <ImageUploader
              Id="Img6"
              key="6"
              onDrop={(...params) => {
                onDrop("Img6", ...params);
              }}
              bgimage={leftintra}
            />{" "}
          </Col>
          <Col>
            {" "}
            <ImageUploader
              Id="Img7"
              key="7"
              onDrop={(...params) => {
                onDrop("Img7", ...params);
              }}
              bgimage={frontintra}
            />{" "}
          </Col>
          <Col>
            {" "}
            <ImageUploader
              Id="Img8"
              key="8"
              onDrop={(...params) => {
                onDrop("Img8", ...params);
              }}
              bgimage={rightintra}
            />{" "}
          </Col>
        </Row>
        <Row>
          <h3>Panoramic Image:</h3>
        </Row>
        <Row>
          {" "}
          <Col className="col-12">
            {" "}
            <ImageUploader
              Id="Img9"
              key="9"
              onDrop={(...params) => {
                onDrop("Img9", ...params);
              }}
              bgimage={panoramic}
            />{" "}
          </Col>
        </Row>
        <Row>
          <h3>Sefalometric Image:</h3>
        </Row>
        <Row>
          <Col className="col-8">
            {" "}
            <ImageUploader
              Id="Img10"
              key="10"
              onDrop={(...params) => {
                onDrop("Img10", ...params);
              }}
              bgimage={sefalometric}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ImagesAndFilesComp;
